// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceLanguageInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');  
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var ObservablePropTypes = require('mobx-react').propTypes;

  var MyPreferenceLanguageInfo = function (props) {    
    var localization = props.localization;
    var currentUser = props.store.model;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols='2'>
          <span className='u_controlHeight control-label'>{localization.getText('COMMON_LABEL_LANGUAGE')}</span>
        </GridLayout.Col>
        <GridLayout.Col cols='10'>
          <GridLayout.Col cols='3' className='u_noPaddingAll'>
             <DropDown options={currentUser.languageList}
                           labelField='language'
                           valueField='cultureName'
                           value={currentUser.cultureName}
                           onChange={notifyChange(currentUser.updateProperty.bind(currentUser, 'cultureName'), EventsUtils.DROPDOWN)}/>
          </GridLayout.Col>
          <GridLayout.Col cols='1'>
          </GridLayout.Col>
          <GridLayout.Col cols='2'>
            <span className='u_controlHeight control-label'>{localization.getText('COMMON_LABEL_DATE_FORMAT')}</span>
          </GridLayout.Col>
          <GridLayout.Col cols='3' className='u_noPaddingAll'>
            <DropDown options={currentUser.dateFormatList}
                          labelField='labelDateFormat'
                          valueField='dateFormat'
                          value={currentUser.dateFormat}
                          onChange={notifyChange(currentUser.updateProperty.bind(currentUser, 'dateFormat'), EventsUtils.DROPDOWN)} />
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  MyPreferenceLanguageInfo.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect()(MyPreferenceLanguageInfo);
})();


// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceLanguageInfo.jsx